<template>
    <div class="info">
        <div class="geo-title">
            <span>{{ title }}</span>
        </div>
        <div :style="`margin: auto; text-align: center`">
            {{ formatValue(min) }}
            <span v-for="(item, index) in colors" :key="index">
                <span class="color-pan" :style="`background:${item};`"></span>
            </span>
            <span class="ml-2">{{ formatValue(max) }}</span>
        </div>
    </div>
</template>
<script>
import colormap from 'colormap';

export default {
    props: {
        min: {
            type: Number,
            default: 1
        },
        max: {
            type: Number,
            default: 2
        },
        title: {
            type: String,
            default: 'Legend'
        }
    },
    data() {
        return {
            colors: null
        };
    },
    created() {
        this.colors = colormap({
            colormap: 'jet',
            nshades: 50,
            format: 'hex',
            alpha: 1
        });
    },
    methods: {
        formatValue(value) {
            if (value % 1 !== 0) {
                return value.toFixed(1);
            }
            return value;
        }
    }
};
</script>
<style lang="scss">
.info {
    padding: 6px 8px;

    .geo-title {
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 5px;
        text-align: center;
    }
    .color-pan {
        text-align: center;
        font-size: 12px;
        padding: 2px 5px;
        label {
            color: white;
        }
    }
}
</style>
